import { Component, FunctionComponent } from "react";
import { Storage as S3 } from "aws-amplify";
import Autocomplete from "react-google-autocomplete";
import { Form, Alert, Card, Col, Row, ListGroupItem, ListGroup } from "react-bootstrap";
import { RouteComponentProps } from "react-router-dom";
import { GetNearbyShopsInput, GetNearbyShopsOutput, ShopInfo, ShopSummary } from "../../client/core";
import ImageUploader from "../form/ImageUploader";
import { Color } from "../../env";
import { Button, variant } from "../form/Button";

export interface UploadMobileImageState {
    addressId: string;
    error: string;
    success: string;
    shops: ShopInfo[]
    selectedShop?: ShopInfo
    image?: File
}

export interface UploadMobileImageProps extends RouteComponentProps {
    googleApiKey: string;
    imageStore: typeof S3;
    getShops: (input: GetNearbyShopsInput) => Promise<GetNearbyShopsOutput | Error>
}

export default class UploadMobileImage extends Component<UploadMobileImageProps, UploadMobileImageState> {
    constructor(props: UploadMobileImageProps) {
        super(props);
        this.state = {
            addressId: "",
            shops: [],
            error: "",
            success: ""
        };
    }

    handleSubmit = async () => {
        if (!this.state.image) {
            return this.setState({
                error: "Please upload the image"
            })
        }

        if (!this.state.selectedShop) {
            return this.setState({
                error: "Please select the shop to upload an image for."
            })
        }

        const imageName = `mobile/shop/${this.state.selectedShop?.id}`
        this.props.imageStore.put(
            imageName,
            this.state.image,
            {
                contentType: "image/jpeg",
            }
        );

        this.setState({
            selectedShop: undefined,
            success: "Image uploaded successful",
            image: undefined,
        })
    }


    handleAddressChange = (place: google.maps.places.PlaceResult) => {
        this.props.getShops({
            addressId: place.place_id!,
            radius: 10000,
        }).then(response => {
            if (response instanceof Error || !response.body) {
                return this.setState({
                    error: "Failed to get shops"
                })
            }

            this.setState({
                shops: response.body?.shops
            })
        })
    };

    render() {
        const props: UploadMobileImageFormProps = {
            error: this.state.error,
            googleApiKey: this.props.googleApiKey,
            shops: this.state.shops,
            selectedShop: this.state.selectedShop,
            success: this.state.success,
            onAddressChange: this.handleAddressChange,
            onImageChange: (image) => this.setState({ image: image }),
            onShopSelect: (shop) => this.setState({ selectedShop: shop, success: "" }),
            onSubmit: this.handleSubmit
        };
        return <UploadMobileImageRegistrationForm {...props} />;
    }
}

export interface UploadMobileImageFormProps {
    error: string;
    success: string;
    googleApiKey: string;
    shops: ShopInfo[]
    selectedShop?: ShopInfo
    onAddressChange: (address: google.maps.places.PlaceResult) => void;
    onImageChange: (logo: File) => void;
    onShopSelect: (shop: ShopInfo) => void;
    onSubmit: () => void;
}

export const UploadMobileImageRegistrationForm: FunctionComponent<UploadMobileImageFormProps> = (props) => (
    <Form>
        <Row>
            <Col xs={12} sm={8} lg={6} style={{ margin: "auto", padding: "1rem" }}>
                <Card>
                    <Card.Body>
                        <Form.Group style={{ "width": "100%" }}>
                            <h4 style={{ textAlign: "center" }}>Upload Mobile Image</h4>
                            <Alert variant={"danger"} show={props.error !== ""}>
                                {props.error}
                            </Alert>
                            <Alert variant={"success"} show={props.success !== ""}>
                                {props.success}
                            </Alert>
                            <Row style={{ marginTop: "1rem" }}>
                                <Row>
                                    <Col xs={12} md={6} lg={4}>
                                        <ImageUploader name="Image" onUpload={file => props.onImageChange(file)} />
                                    </Col>
                                    <Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col style={{ marginBottom: "1rem" }} sm={12}>
                                        <h5 style={{ textAlign: "center", marginTop: "1rem" }}>Find Shops</h5>
                                        <Form.Label>Address</Form.Label>
                                        <Autocomplete
                                            apiKey={props.googleApiKey}
                                            onPlaceSelected={(place) => props.onAddressChange(place)}
                                            style={{
                                                width: "100%",
                                                padding: ".375rem .75rem",
                                                borderRadius: ".25rem",
                                                border: "1px solid #ced4da",
                                            }}
                                            options={{
                                                types: ["address"],
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <ListGroup>
                                            {props.shops.map(shop => (
                                                <ListGroup.Item
                                                    key={shop.id}
                                                    onClick={() => props.onShopSelect(shop)}
                                                    style={{
                                                        cursor: "pointer",
                                                        margin: ".5rem",
                                                        borderWidth: "2px",
                                                        borderColor:
                                                            shop.id === props.selectedShop?.id ? Color.Primary : Color.LightGrey
                                                    }}
                                                    className="d-flex align-items-center"
                                                >
                                                    <Card.Img
                                                        variant="left"
                                                        src={shop.logo}
                                                        style={{ width: "100px", height: "100px", objectFit: "cover", marginRight: "15px" }}
                                                    />
                                                    <div>
                                                        <Card.Title>{shop.name}</Card.Title>
                                                        <Card.Text className="mb-0">{shop.address}</Card.Text>
                                                    </div>
                                                </ListGroup.Item>
                                            ))}
                                        </ListGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Button name="Submit" onClick={() => props.onSubmit()} buttonvariant={variant.Primary} />
                                </Row>
                            </Row>
                        </Form.Group>
                    </Card.Body>
                </Card >
            </Col>
        </Row>
    </Form >
);
